<template>
  <div :class="validationContainerClass" :style="{ height: boxHeight }">
    <v-validate :rules="rules" v-slot="{ errors, classes }" :name="label">
      <div class="form-group">
        <label :for="id">
          {{ label }}
          <div v-if="isRequired" class="is-required">*</div>
        </label>
        <v-select
          ref="select"
          :options="dataSource"
          :label="dataTextField"
          dir="rtl"
          :reduce="(option) => option[dataValueField]"
          :class="{
            'k-is-invalid': classes.invalid,
            clearable: multiple,
            'v-select': !multiple,
            'v-select-multiple': multiple,
          }"
          :disabled="disabled"
          @input="handleInput"
          v-bind="$attrs"
          :multiple="multiple"
          :dropdown-should-open="dropdownShouldOpen"
          @click.native="click"
        >
          <span slot="no-options">موردی یافت نشد.</span>
        </v-select>
      </div>
      <span class="invalid-feedback d-block">{{ errors[0] }}</span>
    </v-validate>
  </div>
</template>
<script>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
export default {
  inheritAttrs: false,
  components: { vSelect },
  data() {
    return {
      flag: true,
    };
  },
  props: {
    validationContainerClass: {
      type: String,
    },
    rules: {
      type: String,
      default: "",
    },
    dataSource: {
      type: Array,
    },
    dataTextField: {
      type: String,
    },
    dataValueField: {
      type: String,
    },
    label: {
      type: String,
      default: "",
    },
    id: {
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isRequired() {
      return this.rules.includes("required");
    },
    boxHeight() {
      // return !this.multiple ? "82px" : "";
    },
  },
  methods: {
    handleInput(_value) {
      this.$emit("input", _value);
      this.$emit("change", _value);
      this.$nextTick(() => {
        if (this.multiple) {
          this.flag = false;
          this.$refs.select.$refs.search.focus();
        }
      });
    },
    dropdownShouldOpen(VueSelect) {
      return (VueSelect.search.length !== 0 || this.flag) && VueSelect.open;
    },
    click() {
      this.flag = true;
    },
  },
};
</script>
<style>
.vs__dropdown-toggle {
  padding-top: 5px !important;
}
.vs__dropdown-toggle button {
  padding-right: 2px !important;
  margin-bottom: 2px;
}
.v-select.vs--multiple.clearable .vs__actions .vs__clear {
  display: block !important;
}
.v-select {
  height: 38px !important;
}
.v-select-multiple {
  min-height: 38px !important;
  height: auto !important;
}
.vs__selected-options {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.vs__selected {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.vs__search {
  text-align: right;
  font-size: 0.85rem !important;
  margin: 0 !important;
}
</style>
